/* eslint-disable */
/**
 * Hero Carousel
 */
import { Component, registerComponent } from 'js/component.js';
import { gsap } from 'gsap';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin.js';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

const componentName = 'hero-carousel';


class HeroCarousel extends Component {

    /** Component elements */
    elements = {
    };

    /** Initialize components */
    init() {

        /* GSAP - REGISTER PLUGINS */
        gsap.registerPlugin(MotionPathPlugin);
        gsap.registerPlugin(ScrollTrigger);

        /* GSAP ON WINDOW LOAD */
        window.addEventListener('load', () => {

            /* Elements To Animate - Desktop */
            const heroBlur = document.querySelectorAll('#blur1');
            const heroVectorLeft = document.querySelectorAll('.Hero-Vector-Left');
            const heroVectorRightA = document.querySelectorAll('.hero-vector-right-A');
            const heroVectorRightB = document.querySelectorAll('.Hero-Vector-Right-B');
            const heroVectorRightC = document.querySelectorAll('.Hero-Vector-Right-Container-C');
            const heroVectorOutline = document.querySelectorAll('.Hero-Vector-Outline-Container');
            const heroVectorSolid = document.querySelectorAll('.Hero-Vector-Solid-Container');
            const heroVectorSolid2Path = document.querySelectorAll('.Hero-Vector-Solid-2-Path');
            const heroVectorMiddle = document.querySelectorAll('.Hero-Vector-Middle');
            const heroText = document.querySelectorAll('.new-hero-text');

            /* Elements To Animate - Mobile */
            const mheroVectorLeft = document.querySelectorAll('.m-Hero-Vector-Left-Container');
            const mheroVectorOutline = document.querySelectorAll('.m-Hero-Vector-Outline-Container');
            const mheroVectorSolid = document.querySelectorAll('.m-Hero-Vector-Solid-Container');
            const mheroVectorMiddle = document.querySelectorAll('.m-Hero-Vector-Middle-Container');
            const mheroText = document.querySelectorAll('.new-hero-text');
            const mheroTextInner = document.querySelectorAll('.new-hero-text-inner');
            const mheroBackground = document.querySelectorAll('.m-Hero-Background');
            const mheroImage = document.querySelectorAll('.hero img');

            /* Initiate Timeline - Paused By Default */
            var tl = gsap.timeline({ paused: false });
            var tl2 = gsap.timeline({ paused: false });

            /* Desktop - Timeline Begins Here */
            gsap.to([heroBlur], {motionPath: {path: "#path",align: "#path",alignOrigin: [0.5, 0.5],autoRotate: false},duration: 10,repeat: -1,ease: "none",delay: .1});
            tl.to(heroVectorLeft, {duration: 1, css: { right: '0%' }, ease: "power2.out"}, "0");
            tl.to(heroVectorMiddle, {duration: 1, css: { opacity: '1' }, ease: "power2.out"}, "0");
            tl.to(heroVectorRightA, {duration: 1, css: { opacity: '0' }, attr: { points: " 0 454 377 454 377 300 454 454" }, ease: "power2.out"}, "0");
            tl.to(heroVectorRightB, {duration: 1, css: { opacity: '0' }, ease: "power2.out"}, "0");
            tl.to(heroVectorRightC, {duration: 0.5, opacity: 0.9}, "0");
            tl.to(heroVectorOutline, {duration: 1, delay:.1, css: { bottom: '0px', top: 'calc(100% - 100px)', opacity: '1' }, ease: "back.inOut(1)"}, "0");
            tl.to(heroVectorSolid, {duration: 1, delay:.1, css: { bottom: '0px', top: 'calc(100% - 140px)', opacity: '1' }, ease: "back.inOut(1)"}, "0");
            tl.to(heroVectorSolid2Path, {duration: 1, delay:.1, css: { x: '10px' }, ease: "back.inOut(1)"}, "0");
            tl.to(heroText, {duration: 0.5, css: { opacity: '1', y: '0' }, ease: "back.inOut(1)"}, "0");

            /* Desktop - Scoll Animations */
            gsap.to('.Hero-Vector-Middle', {y: 100,scrollTrigger: {trigger: '.new-hero-wrapper-outer',start: 'top 100px',end: 'bottom top',scrub: true}});
            gsap.to('.Hero-Vector-Solid', {y: -200,scrollTrigger: {trigger: '.new-hero-wrapper-outer',start: 'top 100px',end: 'bottom top',scrub: true}});
            gsap.to('.new-hero .hero img', {scale: 1.15,scrollTrigger: {trigger: '.new-hero-wrapper-outer',start: 'top 100px',end: 'bottom top',scrub: true}});
            gsap.to('.Hero-Vector-Outline-Container', {y: -100,scrollTrigger: {trigger: '.new-hero-wrapper-outer',start: 'top 100px',end: 'bottom top',scrub: true}});
            gsap.to('.Hero-Vector-Solid-Container-2 svg', {y: 200,scrollTrigger: {trigger: '.new-hero-wrapper-outer',start: 'top 100px',end: 'bottom top',scrub: true}});

            /* Mobile - Timeline Begins Here */
            tl2.to(mheroVectorLeft, {duration: .5, delay: .1, css: {height: '100%' },ease: "back.inOut(1)"}, "0");
            tl2.to(mheroVectorMiddle, {duration: .5, delay:.1, css: { opacity: '1', top: '0' }, ease: "power2.out"}, "0");
            tl2.to(mheroVectorOutline, {duration: .5, css: {top: 'calc(100% - 50px)', rotation: '0', scale: '1' }, ease: "back.inOut(1)"}, "0");
            tl2.to(mheroVectorSolid, {duration: .5, delay:.5, css: {top: 'calc(100% - 30px)', left:'-30', opacity: '1' }, ease: "back.inOut(1)"}, "0");
            tl2.to(mheroText, {duration: 1, delay:.5, css: {y: '0' }, ease: "back.inOut(1)"}, "0");
            tl2.to(mheroTextInner, {duration: .5, delay:.5, css: {opacity: '1', y: '0'}, ease: "back.inOut(1)"}, "0");
            tl2.to(mheroBackground, {duration: .5, delay:.5, css: {opacity: '1'}, ease: "back.inOut(1)"}, "0");
            tl2.to(mheroImage, {duration: .5, delay:.5, css: {opacity: '1'}, ease: "back.inOut(1)"}, "0");

            /* Mobile - Scoll Animations */
            gsap.to('.m-Hero-Vector-Middle-Container', {y: 100,scrollTrigger: {trigger: '.new-hero-wrapper-outer',start: 'top 56px',end: 'bottom top',scrub: true}});
            gsap.to('.m-Hero-Vector-Solid', {y: -20,scrollTrigger: {trigger: '.new-hero-wrapper-outer',start: 'top 56px',end: 'bottom top',scrub: true}});
            gsap.to('.m-Hero-Vector-Outline-Container', {y: -20,scrollTrigger: {trigger: '.new-hero-wrapper-outer',start: 'top 56px',end: 'bottom top',scrub: true}});
            gsap.to('.m-Hero-Vector-Left-Container', {x: -150,scrollTrigger: {trigger: '.new-hero-wrapper-outer',start: 'top 56px',end: 'bottom top',scrub: true}});

            /* GSAP - Timeline Functions */
            function reverseTimeline() {tl.reverse(1);}
            function reverseTimeline2() {tl2.reverse(1);}



            /* DOCUMENT READY */
            $(document).ready(function() {

                // Adjust Carousel Height Based on Content
                function adjustCarouselHeight() {
                    let tallestTextContainer = 0;
                    $('.new-hero .new-hero-text-inner').each(function() {
                        tallestTextContainer = Math.max(tallestTextContainer, $(this).outerHeight());
                    });

                    // Adjust the additional height based on window width
                    const additionalHeight = window.innerWidth > 1268 ? 250 : 450;
                    tallestTextContainer += additionalHeight;
                    $('.new-hero-wrapper-outer').css('height', tallestTextContainer + 'px');
                }

                adjustCarouselHeight();

                $(window).resize(adjustCarouselHeight);

                // Clear Transition Delay
                setTimeout(function() {
                    $('.new-hero-wrapper').removeClass('loading');
                }, 250);


                // Variables
                var $slider = $('.new-hero-wrapper');
                var $slides = $slider.children();
                var currentIndex = 0;
                var slideCount = $slides.length;
                var percentTime;
                var tick;
                var time = 1;
                var progressBarIndex = 0;
                var isPause = false;


                // Initialize carousel
                function showSlide(index) {
                    $slides.removeClass('slick-active');
                    $slides.eq(index).addClass('slick-active');
                }

                window.showSlide = showSlide;

                // Add Button HTML
                $('.progressBarContainer .progressBar').each(function(index) {
                    var progress = "<div class='inProgress inProgress" + index + "'></div>";
                    $(this).html(progress);
                });

                // Toggle play/pause on button click
                $('.play-pause').click(function () {
                    $(this).toggleClass('playing');
                    $(this).toggleClass('paused');
                    isPause = !isPause;
                });

                // Start Progress Bar
                function startProgressbar() {
                    resetProgressbar();
                    isPause = false;
                    percentTime = 0;
                    tick = setInterval(interval, 10);
                }

                // Set Interval Time
                function interval() {
                    if (!isPause) {
                        percentTime += 1 / (time + 7);
                        $('.inProgress' + progressBarIndex).css({  width: percentTime + "%" });
                        $('.inProgress').parent().removeClass('active');
                        $('.inProgress' + progressBarIndex).parent().addClass('active');
                        if (percentTime >= 100) {
                            goToNextSlide();
                            startProgressbar();
                        }
                    }
                }

                // Reset Progress Bar
                function resetProgressbar() {
                    $('.inProgress').css({width: 0 + '%'});
                    clearInterval(tick);
                }

                // Go To Next Slide
                function goToNextSlide() {
                    currentIndex = (currentIndex + 1) % slideCount;
                    showSlide(currentIndex);
                    progressBarIndex = currentIndex;
                    sliderChange();
                }

                // Go To Slide User Selected
                function goToSlide(index) {
                    console.log("SELCTED" + index);
                    currentIndex = index;
                    showSlide(currentIndex);
                    progressBarIndex = currentIndex;
                    sliderChange();
                }

                startProgressbar();

                // Slider Navigation Buttons
                $('.progressBarContainer button').click(function () {
                    clearInterval(tick);
                    var goToThisIndex = $(this).index();
                    goToSlide(goToThisIndex);
                    startProgressbar();
                    sliderChange();
                    $('.play-pause').addClass('playing').removeClass('paused');
                });

                // Slider Animation
                function sliderChange(){
                    tl.timeScale(2);
                    tl2.timeScale(2);
                    reverseTimeline();
                    reverseTimeline2();
                    setTimeout(function() {
                        tl.timeScale(1);
                        tl2.timeScale(1);
                        tl.restart();
                        tl2.restart();
                    }, 500);
                }

                function pause() {
                    isPause = true;
                }

                // Expose to window
                window.pause = pause;
                window.goToSlide = goToSlide;
            });


        }); /* End Window Load */

    }
}

registerComponent(`.${componentName}`, HeroCarousel);
